import type { ChatStatus } from "src/chats/objects/Chat";

export const CHATS_PATH = "/ch";

export const CHATS_STATUS_PATH = CHATS_PATH + "/:chatStatus";
export const CHATS_STATUS_WITH_UUID_PATH =
  CHATS_PATH + "/:chatStatus/:chatUuid";

export function getChatsStatusPath(chatStatus: ChatStatus) {
  return CHATS_STATUS_PATH.replace(":chatStatus", chatStatus);
}

export function getChatDetailPath(chatStatus: ChatStatus, chatUuid: string) {
  return CHATS_STATUS_WITH_UUID_PATH.replace(":chatStatus", chatStatus).replace(
    ":chatUuid",
    chatUuid,
  );
}
